function Branding({ attributes }) {
  const { overlayType, overlayText, overlayFontSize, overlayLink, overlayLogo, overlayTextColor, overlayTextHoverColor, ODFFT, ODFF, ODFST, ODFS } =
    attributes;
  // `${ODFFT}:${ODFF.number + ODFF.unit};${ODFST}:${ODFS.number + ODFS.unit}`
  return (
    <div className="h5vp_video_overlay" style={{ [ODFFT]: ODFF.number + ODFF.unit, [ODFST]: ODFS.number + ODFS.unit }}>
      {overlayType && overlayText && (
        <a style={{ color: overlayTextColor, fontSize: overlayFontSize.number + overlayFontSize.unit }} href={overlayLink}>
          {overlayText}
        </a>
      )}
      {!overlayType && overlayLogo && (
        <a href={overlayLink}>
          <img src={overlayLogo} alt="logo" />
        </a>
      )}
    </div>
  );
}

export default Branding;
